export { default as VouchersCarousel } from './VouchersCarousel';
